import { useMemo } from 'react';
// Components
import { Stack, Typography } from '@mui/material';
import {
  RHFMultiSelect,
  RHFSearchableMultiSelect,
  RHFSearchableSelect,
  RHFSelect,
  RHFTextField,
} from '@Components/hook-form';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import { RGS } from '@Modal/reducers/users/types';

// Styles
import Styles from './CreateRoleContent.module.scss';
import {
  useGetProvidersQuery,
  useGetRolesQuery,
  useGetProvidersFromAllRgsQuery,
} from '@Src/generated.graphql';

const useDropDown = () => {
  const { data: providersData } = useGetProvidersQuery();
  const { data: rolesData } = useGetRolesQuery();
  const { data: providersWithRgs } = useGetProvidersFromAllRgsQuery();
  const roleDropdown = useMemo(
    () =>
      rolesData?.roles?.map(({ name, id }) => (
        <MenuItemEx key={id} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [rolesData]
  );
  const providersDropdown = useMemo(
    () =>
      providersData?.providers?.map(({ name, id }) => (
        <MenuItemEx key={name} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [providersData]
  );

  const providersWithRgsDropdown = useMemo(
    () =>
      providersWithRgs?.providersFromAllRGS?.map(({ providerId, providerName, rgsId }) => (
        <MenuItemEx key={providerId} value={providerId} name="ProvidersWithRgs">
          {`${providerName}(${rgsId.slice(-2)})`}
        </MenuItemEx>
      )),
    [providersWithRgs]
  );
  return {
    roles: roleDropdown,
    providers: providersDropdown,
    providersWithRgs: providersWithRgsDropdown,
  };
};

export const CreateUserContent = () => {
  const dropdown = useDropDown();
  const { data } = useGetProvidersFromAllRgsQuery();

  return (
    <Stack className={Styles.CreateRoleContent}>
      <RHFMultiSelect
        name="games"
        label="games"
        variant="outlined"
        chip
        options={[
          { label: 'Aviator', value: 1 },
          { label: 'Mines', value: 2 },
          { label: 'Rubber Duck', value: 3 },
        ]}
      ></RHFMultiSelect>
      <RHFTextField name="email" label="Email" type="email" />
      <RHFTextField name="password" label="Password" />
      <Stack className={Styles.PasswordRecuirements}>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Length: min - 8, recommended - 14
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Complexity: min - 1 uppercase, 1 lowercase, 1 number, 1 symbol
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Disallowed pattern: Username
        </Typography>
      </Stack>
      <RHFSelect label="Role" name="roleIds" variant="outlined">
        {dropdown.roles}
      </RHFSelect>
      <RHFSearchableMultiSelect name="providerRgs" providers={data?.providersFromAllRGS || []} />
    </Stack>
  );
};
